import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction, FilterOperation, IGraphMessage } from '../../graphql/schema/p4types';
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import DateTimeFormatter from '../../components/grid-addons/formatters/DateTimeFormatter';
import { IWorkspaceColumnOverride } from '../../@types/workspaceTypes';
import GraphMessage from '../../graphql/entities/system/GraphMessage';
import { IEditableDataGridColumnDef } from '../../@types/editableDataGridTypes';

/**
 * Sorting only works if filter for the same field included, special handling added for date in the backend
 */
const OUTLOOK_GRID_COLUMNS: IWorkspaceColumnOverride = {
  receivedDateTime: {
    name: 'Received',
    resizable: true,
    formatter: DateTimeFormatter,
  },
  'from.address': {
    name: 'From - Address',
    resizable: true,
    sortable: false,
  },
  'from.name': {
    name: 'From - Name',
    resizable: true,
    sortable: false,
  },
  'to.address': {
    name: 'To - Address',
    resizable: true,
    sortable: false,
    formatter: (props: {
      dependentValues: {
        rowData: IGraphMessage;
      };
    }) => {
      return props?.dependentValues?.rowData?.to?.map((to) => to!.address).join(', ') || null;
    },
  },
  subject: {
    name: 'Subject',
    resizable: true,
    sortable: false,
  },
};

const availableFiltersFilter = (column: IEditableDataGridColumnDef) => {
  return !column?.fieldName.includes('to') && !column?.fieldName.includes('from');
};

const availableColumnsFilter = (column: IEditableDataGridColumnDef) => {
  return column?.fieldName !== 'to.name';
};

export default function GraphMessageWorkspace(
  props:
    | {
        emailAddresses: string[];
        mailbox: string;
      }
    | any
) {
  const workspaceProps = useWorkspace<IGraphMessage>(
    { ...(props as any), viewScreenName: GraphMessage.workspaceUrl },
    GraphMessage,
    {
      filters: [
        ...props.emailAddresses.map((emailAddress: string) => {
          return {
            filterParameters: {
              field: 'from.address',
              value: emailAddress,
            },
            filterOperation: FilterOperation.Equals,
          };
        }),
        {
          filterParameters: {
            field: 'to',
            value: props.mailbox,
          },
          filterOperation: FilterOperation.Equals,
        },
      ],
      columns: ['receivedDateTime', 'from.address', 'to.address', 'subject'],
      columnOverrides: OUTLOOK_GRID_COLUMNS,
      initialSortColumn: 'receivedDateTime',
      initialSortDirection: Direction.Desc,
    }
  );

  return (
    <Workspace
      title={GraphMessage.title}
      defaultQuery={GraphMessage.workspace}
      entity={GraphMessage}
      entityType={GraphMessage.type}
      includeGenericSearch={false}
      availableFiltersFilter={availableFiltersFilter}
      availableColumnsFilter={availableColumnsFilter}
      slowWorkspace
      {...workspaceProps}
      {...props}
    />
  );
}
